// extracted by mini-css-extract-plugin
export default {"deleteBillingAgreementDialog":"YT1SN","submissionMessage":"ZJGrU"};